import { getSpeciesSpellingSuggestion } from './sightings/corrections';

const normalizeInput = (value) => (
  typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : ''
);

export const reviewAlertSpeciesSpelling = (species, dialogWindow = window) => {
  let reviewedSpecies = normalizeInput(species);

  while (reviewedSpecies) {
    const spellingIssue = getSpeciesSpellingSuggestion(reviewedSpecies);
    if (!spellingIssue) {
      return { cancelled: false, species: reviewedSpecies };
    }

    const useSuggestion = dialogWindow.confirm(
      `Possible spelling error: “${spellingIssue.input}”\n\n`
      + `Did you mean “${spellingIssue.suggestion}”?\n\n`
      + 'OK = use the suggested spelling\n'
      + 'Cancel = edit it or send it as typed',
    );

    if (useSuggestion) {
      return { cancelled: false, species: spellingIssue.suggestion };
    }

    const editedSpecies = dialogWindow.prompt(
      'Edit the animal name below.\n\n'
      + 'To send it exactly as typed, leave it unchanged and press OK.\n'
      + 'To stop sending, press Cancel.',
      reviewedSpecies,
    );

    if (editedSpecies === null) {
      return { cancelled: true, species: reviewedSpecies };
    }

    const normalizedEdit = normalizeInput(editedSpecies);
    if (!normalizedEdit) {
      dialogWindow.alert('Please enter an animal name before sending the alert.');
      continue;
    }

    if (normalizedEdit.toLocaleLowerCase() === reviewedSpecies.toLocaleLowerCase()) {
      return { cancelled: false, species: normalizedEdit };
    }

    reviewedSpecies = normalizedEdit;
  }

  return { cancelled: false, species: reviewedSpecies };
};
